<template>
  <Card :title="name">
    <template v-for="(p, i) in project">
      <Field
        :key="i"
        :readonly="readonly"
        type="digit"
        label-width="60%"
        :label="p.name"
        v-model="p.number"
        placeholder="请输入"
      >
        <template #button>次</template>
      </Field>
    </template>
  </Card>
</template>
<script>
import { Field } from "vant";
import Card from "@/components/trainingManual/card/Card.vue";
export default {
  name: "Project",
  props: {
    id: String,
    readonly: Boolean
  },
  data: function() {
    return {
      name: "三、护理技术操作记录",
      project: []
    };
  },
  methods: {
    getDataById(id) {
      //内/外科培训
      const NWK = [
        { name: "口腔护理", number: null, type: 1, countWay: 1 },
        { name: "会阴冲洗", number: null, type: 1, countWay: 1 },
        { name: "褥疮护理", number: null, type: 1, countWay: 1 },
        { name: "轴线翻身", number: null, type: 1, countWay: 1 },
        { name: "患者转运", number: null, type: 1, countWay: 1 },
        { name: "患者约束", number: null, type: 1, countWay: 1 },
        { name: "出入院护理", number: null, type: 1, countWay: 1 },
        { name: "健康教育", number: null, type: 1, countWay: 1 },
        { name: "床旁交接班", number: null, type: 1, countWay: 1 },
        { name: "给氧", number: null, type: 1, countWay: 1 },
        { name: "雾化吸入", number: null, type: 1, countWay: 1 },
        { name: "痰标本采集", number: null, type: 1, countWay: 1 },
        { name: "咽拭子标本采集", number: null, type: 1, countWay: 1 },
        { name: "静脉输液、输血", number: null, type: 1, countWay: 1 },
        { name: "静脉留置针穿刺", number: null, type: 1, countWay: 1 },
        { name: "静脉采血", number: null, type: 1, countWay: 1 },
        { name: "静脉注射", number: null, type: 1, countWay: 1 },
        { name: "肌肉注射", number: null, type: 1, countWay: 1 },
        { name: "皮下注射", number: null, type: 1, countWay: 1 },
        { name: "皮内注射", number: null, type: 1, countWay: 1 },
        { name: "口服给药", number: null, type: 1, countWay: 1 },
        { name: "指血糖监测", number: null, type: 1, countWay: 1 },
        { name: "PICC护理", number: null, type: 1, countWay: 1 },
        { name: "动脉血标本采集", number: null, type: 1, countWay: 1 },
        { name: "输液泵/微量泵的使用", number: null, type: 1, countWay: 1 },
        { name: "多功能心电监护仪的使用", number: null, type: 1, countWay: 1 },
        {
          name: "简易呼吸皮囊或口咽管使用",
          number: null,
          type: 1,
          countWay: 1
        },
        { name: "呼吸机使用", number: null, type: 1, countWay: 1 },
        { name: "除颤仪使用", number: null, type: 1, countWay: 1 },
        { name: "心肺复苏术", number: null, type: 1, countWay: 1 },
        { name: "气管插管/气管切开护理", number: null, type: 1, countWay: 1 },
        {
          name: "管道护理（尿管、胃管、引流管等）",
          number: null,
          type: 1,
          countWay: 1
        },
        { name: "鼻饲", number: null, type: 1, countWay: 1 },
        { name: "胃肠减压", number: null, type: 1, countWay: 1 },
        { name: "灌肠", number: null, type: 1, countWay: 1 },
        { name: "导尿", number: null, type: 1, countWay: 1 },
        { name: "术前准备", number: null, type: 1, countWay: 1 },
        { name: "伤口/造口换药", number: null, type: 1, countWay: 1 },
        { name: "物理降温", number: null, type: 1, countWay: 1 }
      ];
      //急诊室培训记录
      const JZS = [
        { name: "接诊分诊", number: null, type: 1, countWay: 1 },
        { name: "心电监护", number: null, type: 1, countWay: 1 },
        { name: "输液泵、微量泵使用", number: null, type: 1, countWay: 1 },
        { name: "转运病人（轮椅、平车）", number: null, type: 1, countWay: 1 },
        { name: "给氧", number: null, type: 1, countWay: 1 },
        { name: "吸痰", number: null, type: 1, countWay: 1 },
        { name: "雾化吸入", number: null, type: 1, countWay: 1 },
        { name: "静脉采血或注射", number: null, type: 1, countWay: 1 },
        { name: "动脉采血", number: null, type: 1, countWay: 1 },
        { name: "洗胃术", number: null, type: 1, countWay: 1 },
        { name: "心肺复苏", number: null, type: 1, countWay: 1 },
        { name: "除颤", number: null, type: 1, countWay: 1 },
        { name: "配合气管插管", number: null, type: 1, countWay: 1 },
        { name: "床旁心电图", number: null, type: 1, countWay: 1 }
      ];
      //ICU科培训记录
      const ICU = [
        { name: "经口气管插管口腔护理", number: null, type: 1, countWay: 1 },
        { name: "轴线翻身方法", number: null, type: 1, countWay: 1 },
        { name: "褥疮预防", number: null, type: 1, countWay: 1 },
        { name: "会阴冲洗", number: null, type: 1, countWay: 1 },
        { name: "PICC、CVC导管护理", number: null, type: 1, countWay: 1 },
        {
          name: "气管插管及气管切开的护理",
          number: null,
          type: 1,
          countWay: 1
        },
        { name: "体外振动排痰", number: null, type: 1, countWay: 1 },
        { name: "吸痰", number: null, type: 1, countWay: 1 },
        { name: "血气分析", number: null, type: 1, countWay: 1 },
        { name: "肢体气压治疗", number: null, type: 1, countWay: 1 },
        { name: "简易呼吸器的使用", number: null, type: 1, countWay: 1 },
        { name: "电击除颤", number: null, type: 1, countWay: 1 },
        { name: "CPR", number: null, type: 1, countWay: 1 },
        { name: "物理降温", number: null, type: 1, countWay: 1 },
        { name: "静脉输液、输血", number: null, type: 1, countWay: 1 },
        { name: "动脉血标本采集", number: null, type: 1, countWay: 1 },
        { name: "静脉留置针穿刺", number: null, type: 1, countWay: 1 },
        { name: "ART、CVP监测方法", number: null, type: 1, countWay: 1 },
        { name: "呼吸机使用", number: null, type: 1, countWay: 1 },
        { name: "给氧", number: null, type: 1, countWay: 1 },
        { name: "雾化吸入", number: null, type: 1, countWay: 1 }
      ];
      //手术室科培训记录
      const SSS = [
        { name: "静脉输液", number: null, type: 1, countWay: 1 },
        { name: "静脉输血", number: null, type: 1, countWay: 1 },
        { name: "留置针穿刺", number: null, type: 1, countWay: 1 },
        { name: "导尿", number: null, type: 1, countWay: 1 },
        { name: "无菌技术操作", number: null, type: 1, countWay: 1 },
        { name: "体位安置", number: null, type: 1, countWay: 1 },
        { name: "采集动脉血标本", number: null, type: 1, countWay: 1 },
        { name: "术前访视", number: null, type: 1, countWay: 1 },
        { name: "术前接病人", number: null, type: 1, countWay: 1 },
        { name: "外科术前洗手", number: null, type: 1, countWay: 1 },
        { name: "术后送病人", number: null, type: 1, countWay: 1 },
        { name: "术后回访", number: null, type: 1, countWay: 1 },
        { name: "输液泵、微量泵使用", number: null, type: 1, countWay: 1 },
        { name: "简易呼吸皮囊使用", number: null, type: 1, countWay: 1 },
        { name: "吸痰", number: null, type: 1, countWay: 1 },
        { name: "给氧", number: null, type: 1, countWay: 1 },
        { name: "心电监护", number: null, type: 1, countWay: 1 },
        { name: "心肺复苏", number: null, type: 1, countWay: 1 }
      ];
      //口腔内科
      const KQNK = [
        { name: "初诊接待", number: null, type: 1, countWay: 1 },
        { name: "健康教育", number: null, type: 1, countWay: 1 },
        { name: "电话回访", number: null, type: 1, countWay: 1 },
        { name: "吸引技术", number: null, type: 1, countWay: 1 },
        { name: "软组织牵引技术", number: null, type: 1, countWay: 1 },
        { name: "器械的传递与交换", number: null, type: 1, countWay: 1 },
        {
          name: "玻璃离子水门汀（垫底）的调拌技术",
          number: null,
          type: 1,
          countWay: 1
        },
        {
          name: "磷酸锌水门汀（垫底）的调拌技术",
          number: null,
          type: 1,
          countWay: 1
        },
        {
          name: "玻璃离子（充填）的调拌技术",
          number: null,
          type: 1,
          countWay: 1
        },
        { name: "橡皮障的放置与去除", number: null, type: 1, countWay: 1 },
        { name: "根管治疗的四手操作配合", number: null, type: 1, countWay: 1 },
        {
          name: "光固化复合树脂充填术的护理配合",
          number: null,
          type: 1,
          countWay: 1
        },
        { name: "龈下刮治术的护理配合", number: null, type: 1, countWay: 1 },
        { name: "牙周检查的护理配合", number: null, type: 1, countWay: 1 },
        {
          name: "不合作患儿的诊疗行为诱导",
          number: null,
          type: 1,
          countWay: 1
        },
        { name: "超声雾化吸入的护理配合", number: null, type: 1, countWay: 1 },
        {
          name: "口腔局部活检组织的护理配合",
          number: null,
          type: 1,
          countWay: 1
        },
        { name: "粘膜下局部注射的护理配合", number: null, type: 1, countWay: 1 },
      ];
      //口腔外科系列科培训记录
      const KQ1007 = [
        { name: "初诊接待", number: null, type: 1, countWay: 1 },
        { name: "健康教育", number: null, type: 1, countWay: 1 },
        { name: "电话回访", number: null, type: 1, countWay: 1 },
        { name: "吸引技术", number: null, type: 1, countWay: 1 },
        { name: "软组织牵引技术", number: null, type: 1, countWay: 1 },
        { name: "器械的传递与交换", number: null, type: 1, countWay: 1 },
        { name: "局部麻醉的护理配合", number: null, type: 1, countWay: 1 },
        { name: "智齿冠周炎的护理配合", number: null, type: 1, countWay: 1 },
        { name: "普通牙拔除术的护理配合", number: null, type: 1, countWay: 1 },
        { name: "阻生牙拔除术的护理配合", number: null, type: 1, countWay: 1 },
        { name: "牙槽脊修整术的护理配合", number: null, type: 1, countWay: 1 },
        { name: "根尖囊肿术的护理配合", number: null, type: 1, countWay: 1 },
        { name: "无痛拔牙术的护理配合", number: null, type: 1, countWay: 1 },
        { name: "颌面外科常用手术器械识别", number: null, type: 1, countWay: 1 },

        { name: "出入院护理", number: null, type: 1, countWay: 1 },
        { name: "健康教育", number: null, type: 1, countWay: 1 },
        { name: "床旁交接班", number: null, type: 1, countWay: 1 },
        { name: "晨晚间护理", number: null, type: 1, countWay: 1 },
        { name: "给氧", number: null, type: 1, countWay: 1 },
        { name: "雾化吸入", number: null, type: 1, countWay: 1 },
        { name: "口腔护理", number: null, type: 1, countWay: 1 },
        { name: "中心负压吸痰术", number: null, type: 1, countWay: 1 },
        { name: "鼻饲", number: null, type: 1, countWay: 1 },
        { name: "胃肠减压", number: null, type: 1, countWay: 1 },
        { name: "导尿", number: null, type: 1, countWay: 1 },
        { name: "术前准备", number: null, type: 1, countWay: 1 },
        { name: "伤口换药", number: null, type: 1, countWay: 1 },
        { name: "静脉输液、输血", number: null, type: 1, countWay: 1 },
        { name: "静脉留置针穿刺", number: null, type: 1, countWay: 1 },
        { name: "静脉采血", number: null, type: 1, countWay: 1 },
        { name: "静脉注射", number: null, type: 1, countWay: 1 },
        { name: "肌肉注射", number: null, type: 1, countWay: 1 },
        { name: "皮下注射", number: null, type: 1, countWay: 1 },
        { name: "口腔给药", number: null, type: 1, countWay: 1 },
        { name: "指血糖监测", number: null, type: 1, countWay: 1 },
        { name: "动脉血标本采集", number: null, type: 1, countWay: 1 },
        { name: "多功能心电监护仪的使用", number: null, type: 1, countWay: 1 },
        { name: "输液泵/微量泵的使用", number: null, type: 1, countWay: 1 },
        { name: "气管插管/气管切开护理", number: null, type: 1, countWay: 1 },
        { name: "外科术前洗手", number: null, type: 1, countWay: 1 },
        { name: "无菌技术操作", number: null, type: 1, countWay: 1 },
        { name: "体位安置", number: null, type: 1, countWay: 1 },
        { name: "术前访视", number: null, type: 1, countWay: 1 },
        { name: "术后送病人", number: null, type: 1, countWay: 1 },
        { name: "术后回访", number: null, type: 1, countWay: 1 },
        { name: "物理降温", number: null, type: 1, countWay: 1 }
      ];
      //口腔修复系列科培训记录
      const KQ1008 = [
        { name: "初诊接待", number: null, type: 1, countWay: 1 },
        { name: "健康教育", number: null, type: 1, countWay: 1 },
        { name: "电话回访", number: null, type: 1, countWay: 1 },
        { name: "吸引技术", number: null, type: 1, countWay: 1 },
        { name: "软组织牵引技术", number: null, type: 1, countWay: 1 },
        { name: "器械的传递与交换", number: null, type: 1, countWay: 1 },
        { name: "藻酸盐印模材料的调拌技术", number: null, type: 1, countWay: 1 },
        { name: "硅橡胶印模材料的调拌技术", number: null, type: 1, countWay: 1 },
        { name: "灌注石膏模型技术", number: null, type: 1, countWay: 1 },
        { name: "黏固材料的调拌技术", number: null, type: 1, countWay: 1 },
        { name: "自凝塑胶的调拌技术", number: null, type: 1, countWay: 1 },
        { name: "取印模技术", number: null, type: 1, countWay: 1 },
        { name: "桩冠修复的护理配合", number: null, type: 1, countWay: 1 },
        { name: "纤维桩粘结的护理配合", number: null, type: 1, countWay: 1 },
        { name: "常规种植手术的护理配合", number: null, type: 1, countWay: 1 },
        { name: "种植二期修复的护理配合", number: null, type: 1, countWay: 1 },
        { name: "种植患者档案资料管理", number: null, type: 1, countWay: 1 }
      ];
      //口腔正畸系列科培训记录
      const KQ1009 = [
        { name: "初诊接待", number: null, type: 1, countWay: 1 },
        { name: "健康教育", number: null, type: 1, countWay: 1 },
        { name: "电话回访", number: null, type: 1, countWay: 1 },
        { name: "吸引技术", number: null, type: 1, countWay: 1 },
        { name: "软组织牵引技术", number: null, type: 1, countWay: 1 },
        { name: "器械的传递与交换", number: null, type: 1, countWay: 1 },
        { name: "藻酸盐印模材料的调拌技术", number: null, type: 1, countWay: 1 },
        { name: "自动调合机印模材料的调拌技术", number: null, type: 1, countWay: 1 },
        { name: "灌制正畸模型技术", number: null, type: 1, countWay: 1 },
        { name: "玻璃离子水门汀（粘结）的调拌技术", number: null, type: 1, countWay: 1 },
        { name: "托槽直接粘结的护理配合", number: null, type: 1, countWay: 1 },
        { name: "托槽间接粘结技术", number: null, type: 1, countWay: 1 },
        { name: "正畸治疗患者的面相采集", number: null, type: 1, countWay: 1 },
        { name: "口腔治疗患者的资料管理", number: null, type: 1, countWay: 1 }
      ];
      //口腔综合病区培训记录
      const KQ1010 = [
        { name: "初诊接待", number: null, type: 1, countWay: 1 },
        { name: "健康教育", number: null, type: 1, countWay: 1 },
        { name: "电话回访", number: null, type: 1, countWay: 1 },
        { name: "吸引技术", number: null, type: 1, countWay: 1 },
        { name: "软组织牵引技术", number: null, type: 1, countWay: 1 },
        { name: "器械的传递与交换", number: null, type: 1, countWay: 1 },
        { name: "局部麻醉的护理配合", number: null, type: 1, countWay: 1 },
        { name: "智齿冠周炎的护理配合", number: null, type: 1, countWay: 1 },
        { name: "普通牙拔除术的护理配合", number: null, type: 1, countWay: 1 },
        { name: "阻生牙拔除术的护理配合", number: null, type: 1, countWay: 1 },
        { name: "牙槽脊修整术的护理配合", number: null, type: 1, countWay: 1 },
        { name: "根尖囊肿术的护理配合", number: null, type: 1, countWay: 1 },
        { name: "无痛拔牙术的护理配合", number: null, type: 1, countWay: 1 },
        { name: "颌面外科常用手术器械识别", number: null, type: 1, countWay: 1 },

        { name: "出入院护理", number: null, type: 1, countWay: 1 },
        { name: "健康教育", number: null, type: 1, countWay: 1 },
        { name: "床旁交接班", number: null, type: 1, countWay: 1 },
        { name: "晨晚间护理", number: null, type: 1, countWay: 1 },
        { name: "给氧", number: null, type: 1, countWay: 1 },
        { name: "雾化吸入", number: null, type: 1, countWay: 1 },
        { name: "口腔护理", number: null, type: 1, countWay: 1 },
        { name: "中心负压吸痰术", number: null, type: 1, countWay: 1 },
        { name: "鼻饲", number: null, type: 1, countWay: 1 },
        { name: "胃肠减压", number: null, type: 1, countWay: 1 },
        { name: "导尿", number: null, type: 1, countWay: 1 },
        { name: "术前准备", number: null, type: 1, countWay: 1 },
        { name: "伤口换药", number: null, type: 1, countWay: 1 },
        { name: "静脉输液、输血", number: null, type: 1, countWay: 1 },
        { name: "静脉留置针穿刺", number: null, type: 1, countWay: 1 },
        { name: "静脉采血", number: null, type: 1, countWay: 1 },
        { name: "静脉注射", number: null, type: 1, countWay: 1 },
        { name: "肌肉注射", number: null, type: 1, countWay: 1 },
        { name: "皮下注射", number: null, type: 1, countWay: 1 },
        { name: "口腔给药", number: null, type: 1, countWay: 1 },
        { name: "指血糖监测", number: null, type: 1, countWay: 1 },
        { name: "动脉血标本采集", number: null, type: 1, countWay: 1 },
        { name: "多功能心电监护仪的使用", number: null, type: 1, countWay: 1 },
        { name: "输液泵/微量泵的使用", number: null, type: 1, countWay: 1 },
        { name: "气管插管/气管切开护理", number: null, type: 1, countWay: 1 },
        { name: "外科术前洗手", number: null, type: 1, countWay: 1 },
        { name: "无菌技术操作", number: null, type: 1, countWay: 1 },
        { name: "体位安置", number: null, type: 1, countWay: 1 },
        { name: "术前访视", number: null, type: 1, countWay: 1 },
        { name: "术后送病人", number: null, type: 1, countWay: 1 },
        { name: "术后回访", number: null, type: 1, countWay: 1 },
        { name: "物理降温", number: null, type: 1, countWay: 1 }
      ];
      switch (id) {
        case "1001":
          return NWK;
        case "1002":
          return NWK;
        case "1003":
          return JZS;
        case "1004":
          return ICU;
        case "1005":
          return SSS;
        case "1006":
          return KQNK;
        case "1007":
          return KQ1007;
        case "1008":
          return KQ1008;
        case "1009":
          return KQ1009;
        case "1010":
          return KQ1010;
        default:
          return [];
      }
    }
  },
  mounted() {
    this.project = this.getDataById(this.id);
  },
  components: { Card, Field }
};
</script>
<style lang="scss"></style>
